module.exports = __webpack_public_path__ + "static/media/rainbow.7b5f5e2b.svg";